import Container from '../../components/Container/Container';
import Who from '../../components/who/who';
import { Courses,ContactUs,Activities, Gallery,Team } from '../../components/index';


import './Home.css'

const Home = () => {
    return (
       <>
                <Container/>
                <Who/>
                <Gallery/>
                <Team/>
                <ContactUs/>
                <Activities/>
                <Courses/>
                
                
                
                
                
                
                

       </>

    )
}
export default Home;
